import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { FormControl, InputBase, InputLabel, Menu, MenuItem, Paper } from '@mui/material';
import { AdsClick } from '@mui/icons-material';
import { Tree, TreeNode } from 'react-organizational-chart';
import Service from '../../../util/Service';
import PublicoAlvoUserList from './PublicoAlvoUserList';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiDialog-paper': {
        minWidth: '500px', // Set your desired minimum width here
      },
}));

const StyledNode = (props) => {
    const { item, selected, setSelected, children } = props
    function handleClick() {
        const id = item.id;
        console.log(">>handleClick<<", item )

        const selectedIndex = selected && selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    }
    function isSelecioado() {
        if (!item || !selected) return false;
        const id = item.id;
        const selectedIndex = selected.indexOf(id);
        return selectedIndex >= 0;
    }
    return (
        <div style={{
            padding: '5px',
            borderRadius: '8px',
            display: 'inline-block',
            border: isSelecioado() ? '4px solid blue' : '1px solid green',
            cursor: 'pointer',
            minHeight: 45,
            minWidth: 80
        }}
            onClick={handleClick}
        >
            {children}
        </div>
    )
}
const arrOpts = [
    { nome: 'Todos', tp: 'todos' },
    { nome: 'Equipe', tp: 'equipe' },
    { nome: 'Lista Colaboradores', tp: 'lista' },
    { nome: 'Pessoal', tp: 'pessoal' },
]
const nomeRoot = 'aaaaaaaaaaaaaaaaaaaaaaaa';
export default function PublicoAlvoDialog(props) {
    const { publico, setPublico } = props;

    const [title, setTitle] = React.useState();
    const [open, setOpen] = React.useState(false);
    const [org, setOrg] = React.useState({ nome: nomeRoot });
    const [item, setItem] = React.useState();
    const [lstUser, setLstUser] = React.useState();
    const [selected, setSelected] = React.useState([]);
    const [selectedIndex, setSelectedIndex] = React.useState('equipe');

    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    React.useEffect(() => {
        Service.GET('/api/security/organograma/byLstArvoreNome').then(r => {
            console.log( r );
            console.log(r);
            if (r) {
                setOrg(r);
            }            
        })
    }, [])
    React.useEffect(()=>{
        if( publico) setSelectedIndex( publico.tipo);
    },[publico])

    React.useEffect(() => {
        if (publico) {
            //TODO implementar
        }
    }, [publico])

    React.useEffect(() => {
        if (selectedIndex === 'todos') {
            setTitle("Evento publico");
        } else if (selectedIndex === 'pessoal') {
            setTitle("Evento pessoal");
        } else if (selectedIndex === 'Lista') {
            setTitle("Lista de usuários");
        } else if (selected && org) {
            console.log("aquiii",selected);
            var txt = ""
            for (let s of selected) {
                const item = buscaRecursivo(s, org)
                if (item) {
                    txt += item.nome + " "
                }
            }
            setTitle(txt);
        } else {
            setTitle('');
        }
    }, [selected, selectedIndex])

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    function handleOk() {
        const dado = {
            tipo: selectedIndex
        }
        if (selectedIndex === 'equipe') {
            dado.equipe = selected;
        }
        if (selectedIndex === 'lista') {
            dado.lstUser = lstUser;
        }
        setPublico(dado);
        handleClose();
    }
    function buscaRecursivo(id, no) {
        if (no.id === id) return no;
        else {
            if (no.lstArvore) {
                for (let node of no.lstArvore) {
                    const item = buscaRecursivo(id, node);                    
                    if (item) return item;
                }
            }
        }
        return null;
    }
    function handleMenuEscolha(escolha) {
        setSelectedIndex(escolha);
        handleMenuClose();
    }
    const TreeRecursivo = ({ item }) => {
        return (
            <TreeNode label={
                <StyledNode
                    item={item} selected={selected} setSelected={setSelected}
                >
                    <b>{item.nome}</b>
                </StyledNode>
            }
            >
                {item.lstArvore && item.lstArvore.map((row, index) =>
                    <TreeRecursivo key={item.nome + "-id-" + index} item={row} />
                )}
            </TreeNode>
        )
    }
    function MontaLista() {
        if (selectedIndex !== "lista") return;
        return (
            <PublicoAlvoUserList publico={publico} action={setLstUser}/>
        )
    }
    function MontaPessoal() {
        if (selectedIndex !== "pessoal") return;
        return (
            <Typography variant='h5'>
                Apenas o criador do evento tem visibilidade.
            </Typography>
        )
    }
    function MontaTodos() {
        if (selectedIndex !== "todos") return;
        return (
            <Typography variant='h5'>
                Todos os colaboradores tem visão desse evento!
            </Typography>
        )
    }
    function MontaOrganograma() {
        
        if (selectedIndex !== "equipe") return;
        return (
            <Tree
                lineWidth={'2px'}
                lineColor={'green'}
                lineBorderRadius={'10px'}
                label={
                    <StyledNode
                        item={org}
                        selected={selected} setSelected={setSelected}
                    >
                        <b>{org.nome}</b>

                    </StyledNode>
                }
            >
                {org && org.lstArvore && org.lstArvore.map((arv, index) =>
                    <TreeRecursivo key={"id-" + index} item={arv} />
                )}
            </Tree>
        )
    }
    function montaTxtPublico() {
        if (!publico) return "";
        if (publico.tipo === 'equipe') {
            let txt = 'Visível ' + publico.equipe.length + " equipes";
            if( publico.equipe.length < 3){
                txt="";
                for(let x of publico.equipe){
                    txt +=" "+getNomeRecursivo(x, org);
                }
            }            
            return txt;
        } else return publico.tipo
    }
    function getNomeRecursivo(id, o){
        if( o.id === id){
            return o.nome;
        }else if(o.lstArvore ) {
            for(let novoO of o.lstArvore){
                let nome = getNomeRecursivo(id, novoO);
                if( nome) return nome;
            }
        }
        return null;
    }
    return (
        <React.Fragment>
            <Paper component="div"
                sx={{ p: '0px 0px', display: 'flex', alignItems: 'center', width: '25ch' }}
            >
                <FormControl variant="standard">
                    {/* <InputLabel sx={{ ml: 1, mp:-3, }} htmlFor="pulico-alvo">Publico Alvo</InputLabel> */}
                    <InputBase id="pulico-alvo"
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Publico Alvo"
                        inputProps={{ 'aria-label': 'Publico Alvo', readOnly: true }}
                        value={montaTxtPublico()}
                    // onChange={handleChange}

                    />
                </FormControl>
                <IconButton sx={{ p: '7px' }} aria-label="search" onClick={handleClickOpen}>
                    <AdsClick />
                </IconButton>
            </Paper>

            {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open dialog
      </Button> */}
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}                
                maxWidth="lg"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} >
                    Publico Alvo: {title}
                </DialogTitle>

                <IconButton
                    aria-label="alvo"
                    onClick={handleMenuClick}
                    color="primary"
                    sx={{
                        position: 'absolute',
                        right: 40,
                        top: 8,
                    }}
                >
                    <AdsClick />
                </IconButton>

                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    {MontaTodos()}
                    {MontaOrganograma()}
                    {MontaLista()}
                    {MontaPessoal()}

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleOk}>
                        OK
                    </Button>
                </DialogActions>
            </BootstrapDialog>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                {arrOpts.map((item, id) => (
                    <MenuItem key={id}
                        selected={item.tp === selectedIndex}
                        onClick={() => handleMenuEscolha(item.tp)}
                    >
                        {item.nome}
                    </MenuItem>
                ))}

            </Menu>
        </React.Fragment>
    );
}
